import * as d3 from "d3";

export function drawConnectionLines(plotClassName: any) {
  const svg = d3.select(`svg.${plotClassName}`);
  const clickedPoints = svg.selectAll(".clicked");

  if (clickedPoints.size() < 2) {
    return;
  }

  const points: { x: number; y: number }[] = [];
  clickedPoints.each(function () {
    const cx = parseFloat(d3.select(this).attr("cx"));
    const cy = parseFloat(d3.select(this).attr("cy"));
    points.push({ x: cx, y: cy });
  });

  points.sort((a, b) => a.x - b.x);

  svg.selectAll(".connection-line").remove();

  for (let i = 0; i < points.length - 1; i++) {
    const currentPoint = points[i];
    const nextPoint = points[i + 1];

    svg
      .append("line")
      .attr("class", "connection-line swarm")
      .attr("x1", currentPoint.x)
      .attr("y1", currentPoint.y)
      .attr("x2", nextPoint.x)
      .attr("y2", nextPoint.y)
      .attr("stroke", "#E5945D")
      .attr("stroke-width", 2)
      .raise();
  }
}
